// Generated by scripts/encrypt-evidence.mjs. Public demo material only.
export const DEMO_EVIDENCE = {
  "keyBase64": "Ziw6pW19ryqE0DqWM+3P2HiKEv6WCxVoJf0uNmE59eA=",
  "ivBase64": "awZ6jb5sqxR4g/WQ",
  "plaintextSha256": "be97c2f15639b07cc2ff3b77eed8d362e4c456fcaa6de90e21e9497928e26015",
  "ciphertextSha256": "78ca8c6da79e65381251461e9febae68208cc60fcd6c611233f3d38ea88b53f7",
  "plaintextBytes": 416166,
  "ciphertextBytes": 416182,
  "localCiphertextUrl": "/evidence/bodycam-demo.mp4.enc"
} as const
